<nz-card
  [nzTitle]="cardTitleTpl"
  (click)="isSelectable ? selectLine() : ''"
  [class.line-selected]="selectedLine?.lineId === line?.lineId"
  [class.line-selectable]="isSelectable"
  [attr.data-cy]="'line-card'"
>
  <hr class="sim-divider" />
  <div class="sim-wrapper">
    <div class="sim-dates">
      <div class="sim-timeline-text" *ngIf="line.activationTs">
        {{ SIM_PREFIX + "ACTIVATED_DATE" | translate }}:
        {{ (line.activationTs | localizedDate: formatDate) || "N/A" }}
      </div>
      <div class="sim-timeline-text">
        {{ SIM_PREFIX + "PORT_DATE" | translate }}:
        <span>{{ (line.phoneNumber?.portedTs | localizedDate: formatDate) || "N/A" }}</span>
      </div>
    </div>

    <div class="sim-info-block" *ngIf="line.iccid">
      <div>{{ SIM_PREFIX + "ICCID" | translate }}:</div>
      <div class="sim-info-block-content">
        <div
          nz-tooltip
          [nzTooltipTitle]="line.iccid"
          nz-typography
          nzEllipsis
          *appAccessCtrl="MobileSimAndLineManagementLineTab.id"
          class="cursor-pointer"
          (click)="onIccidClick(line.iccid)"
          [attr.data-cy]="'line-card-iccid'"
        >
          {{ line.iccid }}
        </div>
        <div
          nz-tooltip
          [nzTooltipTitle]="line.iccid"
          nz-typography
          nzEllipsis
          *appAccessCtrlInv="MobileSimAndLineManagementLineTab.id"
        >
          {{ line.iccid }}
        </div>
      </div>
    </div>

    <div class="sim-info-block" *ngIf="device?.manufacturer">
      <div>{{ SIM_PREFIX + "DEVICE_MANUFACTURER" | translate }}:</div>
      <div class="sim-info-block-content">
        {{ device.manufacturer }}
      </div>
    </div>
    <div class="sim-info-block" *ngIf="device?.model">
      <div>{{ SIM_PREFIX + "DEVICE_MODEL" | translate }}:</div>
      <div class="sim-info-block-content">
        {{ device.model }}
      </div>
    </div>
    <div class="sim-info-block" *ngIf="device?.latestAttachTs">
      <div>{{ SIM_PREFIX + "LATEST_ATTACH_TS" | translate }}:</div>
      <div class="sim-info-block-content">
        {{ device.latestAttachTs | date }}
      </div>
    </div>

    <button
      *ngIf="hasActions"
      class="button-actions"
      nz-button
      nz-dropdown
      nzType="primary"
      [nzDropdownMenu]="actionMenu"
    >
      {{ "BUTTON.ACTIONS" | translate }}
    </button>
    <nz-dropdown-menu #actionMenu="nzDropdownMenu">
      <ul nz-menu>
        <ng-container
          *appAccessCtrl="MobileEndUsersOverviewTab.resList.linesSendMessage"
        >
          <ng-container
            *ngIf="
              line.status !== lineStatus.DEACTIVATED &&
              line.status !== lineStatus.TERMINATED
            "
          >
            <li nz-menu-item (click)="sendMessage()">
              {{ SIM_PREFIX + "SEND_MESSAGE" | translate }}
            </li>
          </ng-container>
        </ng-container>

        <!-- <ng-container
          *appAccessCtrl="MobileEndUsersOverviewTab.resList.linesPhoneNumber"
        >
          <ng-container *ngIf="line.status === lineStatus.PENDING">
            <li nz-menu-item (click)="updatePhoneNumber()">
              {{ SIM_PREFIX + "UPDATE_PHONE_NUMBER" | translate }}
            </li>
          </ng-container>
        </ng-container> -->

        <ng-container
          *appAccessCtrl="MobileEndUsersOverviewTab.resList.linesSimSwap"
        >
          <ng-container
            *ngIf="
              (line.status === lineStatus.ACTIVATED ||
                line.status === lineStatus.DEACTIVATED) &&
              line.phoneNumber?.msisdnStatus === msisdnStatus.ACTIVE
            "
          >
            <li nz-menu-item (click)="swapSim()">
              {{ SIM_PREFIX + "SWAP_SIM" | translate }}
            </li>
          </ng-container>
        </ng-container>

        <ng-container
          *appAccessCtrl="MobileEndUsersOverviewTab.resList.linesViewInfo"
        >
          <li nz-menu-item (click)="moreInfo()">
            {{ SIM_PREFIX + "MORE_INFO.BUTTON" | translate }}
          </li>
        </ng-container>
        <ng-container *appAccessCtrl="MobileSimAndLineManagementLineTab.id">
          <li nz-menu-item (click)="goToLineManagement(line.lineId)">
            {{ SIM_PREFIX + "GO_TO_LINE_MANAGEMENT.BUTTON" | translate }}
          </li>
        </ng-container>
      </ul>
    </nz-dropdown-menu>
  </div>
</nz-card>

<ng-template #cardTitleTpl>
  <div class="card-header">
    <nz-tag
      [nzColor]="line.status | ViewComputer: 'VIEW_LINE_STATUS'"
      nz-tooltip
      [nzTooltipTitle]="'GLOBAL_TERMS.LINES.STATUS.' + line.status | translate"
    >
      {{ "GLOBAL_TERMS.LINES.STATUS." + line.status | translate }}
    </nz-tag>
    <nz-tag
      nzColor="default"
      nz-tooltip
      [nzTooltipTitle]="'GLOBAL_TERMS.LINES.TYPE.' + line.lineType | translate"
    >
      {{ "GLOBAL_TERMS.LINES.TYPE." + line.lineType | translate }}
    </nz-tag>
  </div>
  <ng-container *appAccessCtrl="MobileSimAndLineManagementLineTab.id">
    <div *ngIf="line.phoneNumbers?.length" class="phone-numbers-wrapper">
      <ng-container *ngFor="let phoneNumber of line.phoneNumbers">
        <span
          *ngIf="phoneNumber?.phoneNumber"
          nz-tooltip
          [nzTooltipTitle]="phoneNumber?.phoneNumber"
          class="display-phone-number cursor-pointer"
          (click)="onMsisdnClick(phoneNumber?.phoneNumber)"
        >
          {{ phoneNumber?.phoneNumber }}
        </span>
        <span
          *ngIf="!phoneNumber?.phoneNumber && phoneNumber?.preferredAreaCode"
          class="cursor-pointer"
          (click)="goToLineManagement(line.lineId)"
        >
          <span class="header-subtext" nz-typography nzType="secondary">
            {{ "FORM.LABEL.AREA_CODE" | translate }}:
          </span>
          <span>
            {{ phoneNumber?.preferredAreaCode }}
          </span>
        </span>

        <span
          *ngIf="!phoneNumber?.phoneNumber && !phoneNumber?.preferredAreaCode"
        >
          <span class="header-subtext" nz-typography nzType="secondary">
            {{ SIM_PREFIX + "MSISDN_NOT_SELECTED" | translate }}
          </span>
        </span>
      </ng-container>
    </div>
  </ng-container>

  <div *ngIf="line.phoneNumbers?.length" class="phone-numbers-wrapper">
    <ng-container *ngFor="let phoneNumber of line.phoneNumbers">
      <span
        nz-tooltip
        [nzTooltipTitle]="phoneNumber?.phoneNumber"
        *appAccessCtrlInv="MobileSimAndLineManagementLineTab.id"
      >
        {{ phoneNumber?.phoneNumber }}
      </span>
    </ng-container>
  </div>
</ng-template>
